var map = {
	"./base/base.module": [
		"./src/app/base/base.module.ts"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		3
	],
	"./global/calendar/calendar.module": [
		"./src/app/global/calendar/calendar.module.ts",
		4
	],
	"./global/charts/charts.module": [
		"./src/app/global/charts/charts.module.ts",
		5
	],
	"./global/components/components.module": [
		"./src/app/global/components/components.module.ts"
	],
	"./global/forms/forms.module": [
		"./src/app/global/forms/forms.module.ts",
		0
	],
	"./global/maps/maps.module": [
		"./src/app/global/maps/maps.module.ts",
		1
	],
	"./global/tables/tables.module": [
		"./src/app/global/tables/tables.module.ts",
		2
	],
	"./global/widgets/widgets.module": [
		"./src/app/global/widgets/widgets.module.ts",
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;